var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Icon } from "sb-resp-ui";
import { DeviceDetect } from "sb-resp-utils";
import { observer } from "mobx-react";
let SportsCarouselItem = class SportsCarouselItem extends React.Component {
    constructor(props) {
        super(props);
        this.iconClassGenerator = {
            sports: (sport) => (this.props.config.alternative ? "i-o-sport-alt-" : (this.props.config.colorful ? "i-c-sport-" : "i-o-sport-")) + sport.id,
            allSports: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "filter-all-sports",
            favorites: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "filter-fav",
            liveStream: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "filter-ls",
            personalized: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "filter-personalized",
            marketGroups: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "filter-market-groups",
            dates: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "filter-dates"
        };
        this.deviceDetect = DeviceDetect.getInstance();
    }
    getIcon(sport) {
        const iconClass = this.iconClassGenerator[sport.type](sport);
        return iconClass + this.getIconSize();
    }
    getIconSize() {
        return " i-" + (this.props.config.iconSize ? this.props.config.iconSize : "32");
    }
    render() {
        const itemClass = "rj-carousel-item" + (this.props.isSelected ? " rj-carousel-item--active" : "");
        return (React.createElement("div", { className: itemClass, onClick: this.props.handler, "data-uat": "carousel-item-sport" },
            ((this.deviceDetect.isDesktop || !this.props.config.hideSportIconOnMobile)
                ? React.createElement(Icon, { i: this.getIcon(this.props.item) }) : ""),
            React.createElement("div", { className: "rj-carousel-item__details" },
                React.createElement("div", { className: "rj-carousel-item__sportName", "data-uat": "carousel-item-sportName" }, this.props.item.name),
                React.createElement("div", { className: "rj-carousel-item__eventsCount", "data-uat": "carousel-item-eventsCount" }, this.props.item.numberOfEvents))));
    }
};
SportsCarouselItem = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], SportsCarouselItem);
export { SportsCarouselItem };
//# sourceMappingURL=SportsCarouselItem.js.map